import { memo } from 'react';

type TProps = {
  coefficientColor: string;
  coefficientColorBackground: string;
};

export const CoefficientIcon = memo(
  ({ coefficientColor, coefficientColorBackground }: TProps) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5145_3565)">
          <rect fill={coefficientColor} height="24" rx="12" width="24" />
          <path
            d="M8.50772 19V6.148H11.8917C13.4637 6.148 14.6277 6.466 15.3837 7.102C16.1517 7.738 16.5357 8.662 16.5357 9.874C16.5357 10.69 16.3497 11.392 15.9777 11.98C15.6057 12.556 15.0537 13 14.3217 13.312C13.6017 13.624 12.7077 13.78 11.6397 13.78H10.1277V19H8.50772ZM6.94172 16.552V15.382H13.0977V16.552H6.94172ZM6.94172 13.78V12.412H11.0637V13.78H6.94172ZM11.4057 12.412C12.1377 12.412 12.7557 12.334 13.2597 12.178C13.7757 12.022 14.1717 11.764 14.4477 11.404C14.7237 11.044 14.8617 10.552 14.8617 9.928C14.8617 9.112 14.6097 8.506 14.1057 8.11C13.6017 7.714 12.8157 7.516 11.7477 7.516H10.1277V12.412H11.4057Z"
            fill={coefficientColorBackground}
          />
        </g>
        <defs>
          <clipPath id="clip0_5145_3565">
            <rect fill="white" height="24" rx="12" width="24" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
